import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from "react-i18next";
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";
import {COUNTRIES} from "../utils/country";
import {getPhoneCode} from "libphonenumber-js";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import Icon from "../componentsReusable/Icon";

const CountryCodeDropdown = props => {
  const inputRef = React.useRef()
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [searchText, setSearchText] = React.useState('')

  useAfterUpdateEffect(() => {
    if(dropdownOpen){
      inputRef.current.focus()
    }else{
      setSearchText('')
    }
  }, [dropdownOpen])

  const getLabelSelected = () => {
    switch (props.type) {
      case 'flag': {
        return <div className={'h-auto'}>
          <Icon className={`fi fi-${props.countryCode.toLowerCase()}`}/>
        </div>
      }
      case "phoneNumber": {
        return <span>+{props.countryCode && getPhoneCode(props.countryCode)}</span>
      }
      default: {
        return props.countryCode
      }
    }
  }

  const getDropdownItemInner = (countryCode) => {
    switch (props.type) {
      case 'flag': {
        return <>
          <Icon className={`fi fi-${countryCode.toLowerCase()}`} tooltip={t(`country:${countryCode}`)} />
          <span className="ml-2">{countryCode}</span>
        </>
      }
      case "phoneNumber": {
        return <>
          <Icon className={`fi fi-${countryCode.toLowerCase()}`} tooltip={t(`country:${countryCode}`)} />
          <span className="ml-2">+{getPhoneCode(countryCode)}</span>
        </>
      }
      default: {
        return countryCode
      }
    }
  }

  const getOptions = () => {
    return COUNTRIES
      .filter(countryCode => (
        !searchText
        || countryCode.toLowerCase().includes(searchText.toLowerCase())
        || t(`country:${countryCode}`).toLowerCase().includes(searchText.toLowerCase())
        || getPhoneCode(countryCode).toLowerCase().includes(searchText.toLowerCase())
      ))
      .sort((a, b) => b === props.countryCode ? 1 : -1)
  }

  return <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
    {dropdownOpen && <input
      ref={inputRef}
      onChange={e => setSearchText(e.target.value)}
      style={{width: 0, height: 0, padding: 0, border: 'none', position: 'absolute', top: 0, left: 0, opacity: 0, zIndex: -1000}}
      value={searchText}
    />}
    <DropdownToggle tag={'div'} className="input-group-text cursor-pointer">
      {getLabelSelected()}
    </DropdownToggle>
    <DropdownMenu style={{ maxHeight: '200px', overflow: 'hidden', overflowY: 'scroll', width: 105, minWidth: 105 }}>
      {getOptions().map((countryCode, key) => <DropdownItem key={key} active={countryCode === props.countryCode} onClick={() => props.onChange(countryCode)}>
        {getDropdownItemInner(countryCode)}
      </DropdownItem>)
      }
    </DropdownMenu>
  </Dropdown>
};

CountryCodeDropdown.propTypes = {
  type: PropTypes.oneOf(['phoneNumber', 'flag']).isRequired,
  countryCode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CountryCodeDropdown;